import { AssociationId, ProfilePk } from '../types'

export class FilePathProvider {
  static getRemoteProfilePicFilePath(profilePk: ProfilePk) {
    return `People/${profilePk}/FaceShots/center`
  }

  static getRemoteDocumentFilePath(profilePk: ProfilePk, association: AssociationId, docName: string) {
    return `People/${profilePk}/Documents/${association}/${docName}`
  }
}
